//* Imports
import Countries from "./Countries";

//* Home JSX
function Home() {
  return (
    <div className="w-full dark:bg-whale-dark bg-whale-light">
      <div className="flex flex-col items-center justify-center gap-20 px-5 mx-auto ">
        <Countries />
        <em>Copyright © 2024 CountryApp Developed by&nbsp;<a href="https://sosamson.com" target = "_blank" 
            rel = "noopener noreferrer">Sosamson</a>. All rights reserved.</em>
      </div>
    </div>
  );
}

export default Home;
